// Enum is ordered
export enum BoundaryCreateWMSOptimizedStatus {
  ProcessingStarted = 'Processing Started',
  ValidatingRequest = 'Validating Request',
  InitializingTerritories = 'Initializing Territories',
  BalancingTerritories = 'Balancing Territories',
  RebalancingTerritories = 'Rebalancing Territories',
  FinalizingTheBalancingOfTerritories = 'Finalizing the Balancing of Territories',
  ProcessingFinished = 'Processing Finished',
  CalculatingStatistics = 'CalculatingStatistics',
  Finished = 'Finished',
}

export const INITIAL_BOUNDARY_CREATE_WMS_OPTIMIZED_STATUS = BoundaryCreateWMSOptimizedStatus.ProcessingStarted;

export type BoundaryCreateWMSOptimizedItem = {
  type: 'WMS';
  id: number;
  isFailed: boolean;
  status: BoundaryCreateWMSOptimizedStatus;
  startedOnCurrentTab: boolean;
};

export type BoundaryCreateWMSOptimizedState = Readonly<{
  pendingItems: ReadonlyArray<BoundaryCreateWMSOptimizedItem>;
}>;
